import { defineComponent } from "@vue/composition-api";
import { tokenize, registerPlugin, init } from "linkifyjs";
import plugin from "linkifyjs/plugins/mention";
import { IS_BROWSER } from "@/lib/browserUtils";
registerPlugin("mentionPlugin", plugin);
init();

export default defineComponent({
  name: "LinkifiedText",
  functional: true,
  props: {
    mentions: { type: Boolean, default: true },
    links: { type: Boolean, default: false },
    externalLinks: { type: Boolean, default: false },
  },
  render(h, { scopedSlots, data, listeners, props }) {
    const inputText = scopedSlots.default({})?.[0].text ?? "";
    const splitText = tokenize(inputText);

    const nodes = splitText.map((token: any) => {
      if (token.t === "mention" && props.mentions) {
        return h("router-link", { props: { to: { name: "profile", params: { username: token.v.substring(1) } } } }, [
          token.v,
        ]);
      }
      const host = IS_BROWSER ? window.location.host : this.$ssrContext.host;
      if (token.t === "url" && props.links && (props.externalLinks || token.v.includes(host.replace(/.*www./, "")))) {
        const prefix = !token.v.toLowerCase().startsWith("http") ? "http://" : "";
        return h("a", { class: ["link", "__underline"], attrs: { href: `${prefix + token.v}`, target: "_blank" } }, [
          token.v,
        ]);
      }

      return token.v;
    });

    return h("div", { ...data, on: listeners }, nodes);
  },
});
